import Vue from 'vue';
import Vuex from 'vuex';

import error from './modules/error';
import registration from './modules/registration';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    error: error,
    registration: registration
  }
});

export default store;
